import $ from 'jquery';
import React from 'react';
import { isMobile } from '../../constants/Constants';

class ExportPopUp extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    $(document).on('openPopUp', this.handleOpenPopUp);
  }

  componentWillUnmount() {
    $(document).off('openPopUp', this.handleOpenPopUp);
  }

  /**
   * Method to handle 'openPopUp' custom event
   * @param {Event} event
   * @param {string} target
   */
  handleOpenPopUp = () => {
    if (this.timeoutID) {
      this.props.restorePopUpConfiguration(this.timeoutID, '#copy-settings-btn');
    }
  };

  /**
   * Method that is called after a timeout to revert the Copy Button to the initial state
   */
  clearCopytButtonTimeout = () => {
    $(document).trigger(isMobile ? 'touchend' : 'mousedown', ['exportPopUp']);
    $('#copy-settings-btn').text('Copy');
    clearTimeout(this.timeoutID);
  };

  /**
   * Method to copy settings into the clipboard
   */
  onCopy = () => {
    navigator.clipboard.writeText(JSON.stringify(this.props.exportData, null, 2));
    $('#copy-settings-btn').text('Copied');
    this.timeoutID = setTimeout(this.clearCopytButtonTimeout, 1000);
  };

  render() {
    return (
      <div id="export-settings">
        <div id="export-settings-content">
          <pre>{JSON.stringify(this.props.exportData, null, 2)}</pre>
        </div>
        <div id="copy-settings-btn" className="popUpBtn" onClick={() => this.onCopy()}>
          Copy
        </div>
      </div>
    );
  }
}

export default ExportPopUp;
